function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(85.09804%,32.549021%,30.980393%)",
      fillOpacity: 1
    },
    d: "M 4.800781 0 L 19.199219 0 C 21.851562 0 24 2.148438 24 4.800781 L 24 19.199219 C 24 21.851562 21.851562 24 19.199219 24 L 4.800781 24 C 2.148438 24 0 21.851562 0 19.199219 L 0 4.800781 C 0 2.148438 2.148438 0 4.800781 0 Z M 4.800781 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 34.99349 34.99349 L 65.00651 34.99349 C 67.757161 34.99349 70.003255 37.239583 70.003255 40.00651 L 70.003255 70.003255 C 70.003255 72.753906 67.757161 75 65.00651 75 L 34.99349 75 C 32.242839 75 29.996745 72.753906 29.996745 70.003255 L 29.996745 40.00651 C 29.996745 37.239583 32.242839 34.99349 34.99349 34.99349 Z M 34.99349 34.99349 ",
    transform: "matrix(0.24,0,0,0.24,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 25 34.99349 L 75 34.99349 ",
    transform: "matrix(0.24,0,0,0.24,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 40.00651 25 C 46.663411 18.326823 53.336589 18.326823 59.99349 25 ",
    transform: "matrix(0.24,0,0,0.24,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 41.992188 45.003255 L 41.992188 70.003255 ",
    transform: "matrix(0.24,0,0,0.24,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 50 45.003255 L 50 70.003255 ",
    transform: "matrix(0.24,0,0,0.24,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 58.007813 45.003255 L 58.007813 70.003255 ",
    transform: "matrix(0.24,0,0,0.24,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0c5258f800d2f21a782559578a94aeee.svg";
export { ForwardRef as ReactComponent };